import { OperatorLookupBillingResponseItem, OperatorLookupBillingTableData } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: OperatorLookupBillingResponseItem[]
): OperatorLookupBillingTableData[] =>
  data.map((current: OperatorLookupBillingResponseItem) => ({ ...current, cost: current.cost.value }));
